export default __webpack_public_path__ + "static/media/question-mark.dac668b4.png";